import { NgModule } from '@angular/core';
import { CustomUserCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';
import { provideNgxMask } from 'ngx-mask';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        mobileMenuLoginButton: {
          module: () => import('./mobile-menu-login-button').then((m) => m.MobileMenuLoginButtonModule),
          cmsComponents: [CustomUserCmsComponents.LoginComponent],
        },
        loginForm: {
          module: () => import('./login-form').then((m) => m.LoginFormModule),
          cmsComponents: [CustomUserCmsComponents.ReturningCustomerLoginComponent],
        },
        switchProfile: {
          module: () => import('./switch-profile').then((m) => m.SwitchProfileModule),
          cmsComponents: [CustomUserCmsComponents.SwitchProfileComponent],
        },
        loginButton: {
          module: () => import('./login-button').then((m) => m.LoginButtonModule),
          cmsComponents: [CustomUserCmsComponents.SdCMSLoginButtonComponent],
        },
        loginLoyalty: {
          module: () => import('./login-loyalty').then((m) => m.LoginLoyaltyModule),
          cmsComponents: [CustomUserCmsComponents.LoginLoyaltyComponent],
        },
      },
    }),
  ],
  providers: [provideNgxMask()],
})
export class UserUiModule {}
